import React, { useEffect, useRef, useState } from "react";
import { TPrivacyStatementProps } from "../../types/PrivacyStatement.types";
import { PrivacyStatementModel } from "../../models/PrivacyStatement.model";
import { windowService } from '../../../../utils/window.utils.js';
import SectionContent from "../SectionContent";
import Dropdown from "../Dropdown";
import SectionTabs from "./SectionTabs";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { generatePDF } from "../../../../utils/generatePDF";

const DesktopPrivacyStatement = (props: TPrivacyStatementProps) => {
    const model = new PrivacyStatementModel(props);
    const typeCollectionMap = model.typeCollection;
    const getQuery = () => new URLSearchParams(windowService().location?.search);
    const contentWrapperRef = useRef<HTMLDivElement | null>(null);
    const [language, setLanguage] = useState('');
    const [type, setType] = useState('');
    const [langCollection, setLangCollection] = useState<string[]>(() => {
        const typ = getQuery().get('type');
        return (typ ? typeCollectionMap.get(typ) : typeCollectionMap.values().next().value) ?? []
    });
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        windowService()?.scrollTo(0, 0);
        const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
        const lngQuery = getQuery('lan');
        const typQuery = getQuery('type');
        if (lngQuery && typQuery) {
            setLanguage(lngQuery);
            setType(typQuery)
        }
    }, []);


    const updateUrlQueryStringParams = (): void => {
        const queries = getQuery();

        const updateUrlParams = (key, newVal: string) => {
            if (newVal.trim() !== '') {
                queries.set(key, newVal);
            } else {
                queries.delete(key);
            }
        };

        updateUrlParams('lan', language ?? '');
        updateUrlParams('type', type ?? '');
        navigate(`?${queries.toString()}`);
    };

    const onTypeSelect = (type: string) => {
        setType(type);
        setLangCollection(typeCollectionMap.get(type) ?? []);
        setLanguage('');
    }

    return (
        <section className="privacy-statement-v2">
            <div className="privacy-statement-v2__container">
                <div ref={contentWrapperRef} className="privacy-statement-v2__content-wrapper">
                    <div className="privacy-statement-v2__title">{model.title.value}</div>
                    <section className="privacy-statement-v2__content">
                        {
                            model?.items ? 
                            model?.items && model.items.map((item) => {
                                return (
                                    <div className="privacy-statement-v2__content-tab" id={item.id}>
                                        <SectionContent {...item} />
                                    </div>
                                )
                            }): <div>{model.defaultEmptyMessage.value}</div> 
                        }
                    </section>
                </div>
                <div className="privacy-statement-v2__tabs-wrapper">
                    <Dropdown
                        Collection={model.typeCollectionArray}
                        changeTitle={model.typeTitle?.value || ''}
                        defaultTitle={model.defaultLanguageTitle?.value || ''}
                        onSelect={onTypeSelect}
                        preSelected={type}
                    />
                    <Dropdown
                        Collection={[...langCollection]}
                        changeTitle={model.languageTitle?.value || ''}
                        defaultTitle={model.defaultLanguageTitle?.value || ''}
                        onSelect={setLanguage}
                        preSelected={language ?? ''}
                    />
                    <div className={'privacy-statement-v2__dropdown__cta-container'}>
                        <div className="privacy-statement-v2__button privacy-statement-v2__button-primary-red privacy-statement-v2__dropdown__primary-cta">
                            <button
                                onClick={() => generatePDF()}>
                                <Text tag={'div'} field={{ value: t('cnhi-generate-pdf') as string }} editable={false} /></button>
                        </div>
                        <div className="privacy-statement-v2__button privacy-statement-v2__button-primary-red privacy-statement-v2__dropdown__primary-cta">
                            <button
                                onClick={() => { if (language && type) updateUrlQueryStringParams() }}><Text tag={'div'} field={{ value: t('cnhi-submit') as string }} editable={false} /></button>
                        </div>
                    </div>
                   <SectionTabs contentWrapperRef={contentWrapperRef} privacyContentItems={model.items} /> 
                </div>
            </div>
        </section>
    );
}

export default DesktopPrivacyStatement;